import { render, staticRenderFns } from "./DivorceLawsuitPage.vue?vue&type=template&id=7a585bfa&scoped=true"
import script from "./DivorceLawsuitPage.vue?vue&type=script&lang=js"
export * from "./DivorceLawsuitPage.vue?vue&type=script&lang=js"
import style0 from "./DivorceLawsuitPage.vue?vue&type=style&index=0&id=7a585bfa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a585bfa",
  null
  
)

export default component.exports